exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.contacts-tray[data-v-068eccb8] {\n\tmax-height: 150px;\n\toverflow-y: scroll;\n\toverflow-x: hidden;\n\tpadding: 10px;\n}\n", ""]);

// exports
